// extracted by mini-css-extract-plugin
module.exports = {"BundlesCommon":"TabBundles_BundlesCommon__ZtR15","BundlesCommon3":"TabBundles_BundlesCommon3__D5xfk"};